var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OrderValidation } from './../orderValidation';
import { CurrentOrderService } from './../currentOrder.service';
import { Component } from '@angular/core';
import { Injectable } from '@angular/core';
import { MixpanelService } from '../../mixpanel/mixpanel.service';
import { LocalStorageService } from '../../localstorage.service';
var OrderShippingComponent = (function () {
    function OrderShippingComponent(currentOrderService, orderValidation, mixpanelService, localStorage) {
        this.currentOrderService = currentOrderService;
        this.orderValidation = orderValidation;
        this.mixpanelService = mixpanelService;
        this.localStorage = localStorage;
        this.mixpanelService.trackEvent("shipping page", null);
    }
    OrderShippingComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.currentOrderService.setMenuVisibility({
            part: true,
            address: true,
            billing: true,
            shipping: true,
            summary: false,
            completed: false
        });
        this.currentOrderService.order.subscribe(function (order) { return _this.order = order; });
        if (this.localStorage.getItem('order.ispartialdelivery') != null
            && this.order.IsPartialDelivery == false)
            this.order.IsPartialDelivery = JSON.parse(this.localStorage.getItem("order.ispartialdelivery"));
        if (this.localStorage.getItem('order.shippingmethod') != null
            && this.order.ShippingMethod == "")
            this.order.ShippingMethod = this.localStorage.getItem("order.shippingmethod");
        if (this.localStorage.getItem('order.couriername') != null
            && this.order.CourierName == "")
            this.order.CourierName = this.localStorage.getItem("order.couriername");
        if (this.localStorage.getItem('order.courieraccountnumber') != null
            && this.order.CourierAccountNumber == "")
            this.order.CourierAccountNumber = this.localStorage.getItem("order.courieraccountnumber");
        if (this.localStorage.getItem('order.othercouriername') != null
            && this.order.OtherCourierName == "")
            this.order.OtherCourierName = this.localStorage.getItem("order.othercouriername");
        if (this.localStorage.getItem('order.deliverymethod') != null
            && this.order.DeliveryMethod == "")
            this.order.DeliveryMethod = this.localStorage.getItem("order.deliverymethod");
    };
    OrderShippingComponent.prototype.checkField = function (event) {
        if (event.target.parentElement.className.match(/(?:^|\s)has-error(?!\S)/))
            event.target.parentElement.className = event.target.parentElement.className.replace(/(?:^|\s)has-error(?!\S)/g, '');
        if (event.target.value == '') {
            event.target.parentElement.className += " has-error";
        }
    };
    OrderShippingComponent.prototype.getShippingMethodFieldsClass = function () {
        return this.orderValidation.getShippingMethodFieldsClass();
    };
    OrderShippingComponent.prototype.getDeliveryMethodFieldsClass = function () {
        return this.orderValidation.getDeliveryMethodFieldsClass();
    };
    OrderShippingComponent.prototype.isValid = function () {
        return this.orderValidation.isShippingValid();
    };
    OrderShippingComponent.prototype.resetForm = function () {
        this.order.IsPartialDelivery = false;
        this.order.ShippingMethod = "";
        this.order.CourierName = "";
        this.order.OtherCourierName = "";
        this.order.CourierAccountNumber = "";
        this.order.DeliveryMethod = "";
    };
    OrderShippingComponent = __decorate([
        Component({
            selector: 'cx-ordershipping',
            templateUrl: './ordershipping.component.html',
        }),
        __metadata("design:paramtypes", [CurrentOrderService,
            OrderValidation,
            MixpanelService,
            LocalStorageService])
    ], OrderShippingComponent);
    return OrderShippingComponent;
}());
export { OrderShippingComponent };
var OrderShippingGuard = (function () {
    function OrderShippingGuard(orderValidation) {
        this.orderValidation = orderValidation;
    }
    OrderShippingGuard.prototype.canActivate = function () {
        return this.orderValidation.isBillingValid();
    };
    OrderShippingGuard = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [OrderValidation])
    ], OrderShippingGuard);
    return OrderShippingGuard;
}());
export { OrderShippingGuard };
//# sourceMappingURL=ordershipping.component.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/order/wizard/ordershipping.component.js
// module id = 192
// module chunks = 0